/** Quill emits `<p><br></p>` (and variants) for an emptied rich-text editor. */
const EMPTY_RICH_TEXT = /^<p>(<br\s*\/?>|&nbsp;|\s)*<\/p>$/i;

export const isBlankTranslation = (
  text: string | undefined | null
): boolean => {
  if (!text) return true;

  const trimmed = text.trim();
  if (!trimmed) return true;

  return EMPTY_RICH_TEXT.test(trimmed);
};
